
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { Store, } from '~/apps/move-out/store';
import ProgressSteps from '~/components/move-out/move-out-progress-steps.vue';
import Spinner from '~/components/spinner/spinner.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';
import 'core-js/es/string/pad-start';

@Component({
	components: {
		Alert: () => import('~/components/alert/alert.vue'),
		Overlay: () => import('~/components/overlay/overlay.vue'),
		ProgressSteps,
		Spinner,
		UnauthedNav,
	},
	metaInfo: {
		title: 'Quick move out - Southern Water',
		meta: [
			{
				name: 'description',
				content: 'If you\'re no longer responsible for paying the Southern Water bill or are moving out of our supply area, then use our online services to close your account.',
			},
		],
	},
})
export default class MoveOutApp extends Vue {
	get currentStep() {
		return Store.state.currentStep;
	}

	get showSpinner() {
		return Store.state.showSpinner;
	}

	get activeAlert() {
		return Store.state.alertModule.activeAlert;
	}

	get showOverlay() {
		return Store.state.isOverlayVisible;
	}

	get overlayMessage() {
		return Store.state.overlayMessage;
	}

	get meterReading() {
		return Store.state.currentMeterReading;
	}

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	closeAlert() {
		Store.commit.dismissActiveAlert();
	}

	closeOverlay() {
		Store.commit.setMeterReading(0);
		Store.commit.closeOverlay();
	}

	overlaySubmit() {
		Store.commit.closeOverlay();
		void this.$router.push('./forwarding-address');
	}

	@Watch('$route')
	onRouteChange() {
		this.$nextTick(() => {
			const focusTarget = document.querySelector('header') as HTMLElement;
			focusTarget.setAttribute('tabindex', '-1');
			focusTarget.focus();
			focusTarget.removeAttribute('tabindex');
		});
	}
}
